// extracted by mini-css-extract-plugin
export default {"root":"DeleteAvatarModal_root__qWUeD","container":"DeleteAvatarModal_container__trcXM"};